export const LINKS = {
  community: "https://chat.whatsapp.com/EFCY0nV39S8EAeV8Eq1652",
  status:
    "https://wa.me/18484022981?text=Hi%2C%20I%E2%80%99d%20like%20to%20subscribe%20to%20the%20JGW%20status",
  advertise:
    "https://wa.me/18484022656?text=Hi%2C%20I%E2%80%99d%20like%20to%20advertise%20with%20Jewish%20Global%20Wire",
  email: "mailto:jewishglobalwire@gmail.com",
  emailAddress: "jewishglobalwire@gmail.com",
  phoneDisplay: "+1 (848) 402-2656",
  phoneHref: "tel:+18484022656",
  statusPhoneDisplay: "+1 (848) 402-2981",
  statusPhoneHref: "tel:+18484022981",
};

export const NAV_ITEMS = [
  { label: "Home", href: "#home" },
  { label: "Latest", href: "#latest" },
  { label: "Join JGW", href: "#join" },
  { label: "About", href: "#about" },
  { label: "Advertise", href: "#advertise" },
  { label: "Contact", href: "#contact" },
];

export const scrollToSection = (e, href) => {
  e.preventDefault();
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
